import isEmpty from "lodash/isEmpty";

import { RequestApprovalSubmitData } from "./use_request_approval_submit";

export const areRequestApprovalDataFilled = ({
  currentBookings,
  activityId,
  profileFrom,
  profileTo,
  finalApprover,
  note
}: RequestApprovalSubmitData): boolean =>
  !isEmpty(currentBookings) &&
  !!activityId &&
  !!profileFrom?.id &&
  !!profileTo?.id &&
  !!finalApprover?.id &&
  !isEmpty(note);
